/**
 * @copyright Copyright (c) 2024 COOREAL. All rights reserved.
 * @author wcfan 
 * @date 2024-08-08.
 * @description 提供cooreal ui 主入口。
 **/
import { App } from "vue";
// 导入创建的插件
import Plugin, { KrPluginOptions } from "./plugin";

export default {
  async install(app: App, option?: KrPluginOptions) {
    return await new Promise(async (resolve) => {
      await Plugin.install(app, option);
      resolve(app);
    });
  },
};
export * from "@cooreal-ui/components";
export * from "@cooreal-ui/ant-components";
export * from "@cooreal-ui/assets";
export * from "@cooreal-ui/core";
export * from "@cooreal-ui/services";
export * from "@cooreal-ui/hooks";
export * from "@cooreal-ui/themes/ant";
